import React from 'react';
import type { LegalPage } from './LegalModal';
interface FooterProps {
  onOpenLegal: (page: LegalPage) => void;
}
const WHATSAPP_URL = 'https://wa.me/34690752576?text=Hola%2C%20he%20visto%20tu%20web%20y%20me%20gustar%C3%ADa%20recibir%20informaci%C3%B3n%20sobre%20tus%20sesiones%20%F0%9F%99%8F';
export function Footer({
  onOpenLegal
}: FooterProps) {
  return <footer className="bg-stone-900" data-id="element-96">
      <div className="max-w-4xl mx-auto px-6 py-14 text-center" data-id="element-97">
        {/* Logo */}
        <a href="#" className="inline-block mb-4" data-id="element-98">
          <img src="https://cdn.magicpatterns.com/uploads/xuDAwxwFr6VPeApRcb2yoF/liftapp_(2).png" alt="Vanii" className="h-10 w-auto object-contain mx-auto" data-id="element-99" />
        </a>

        <p className="text-stone-500 text-sm font-light mb-8 max-w-sm mx-auto" data-id="element-100">
          Acompañamiento espiritual y terapéutico para tu transformación.
        </p>

        {/* Navigation */}
        <nav className="flex items-center justify-center gap-2 text-sm font-light text-stone-400 mb-4" data-id="element-101">
          <a href="#sobre-mi" className="hover:text-violet-400 transition-colors" data-id="element-102">
            Sobre mí
          </a>
          <span className="text-stone-700" data-id="element-103">·</span>
          <a href="#servicios" className="hover:text-violet-400 transition-colors" data-id="element-104">
            Servicios
          </a>
          <span className="text-stone-700" data-id="element-105">·</span>
          <a href="#testimonios" className="hover:text-violet-400 transition-colors" data-id="element-106">
            Testimonios
          </a>
        </nav>

        {/* Contact */}
        <div className="flex items-center justify-center gap-2 text-sm font-light text-stone-400 mb-10" data-id="element-107">
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="hover:text-green-400 transition-colors" data-id="element-108">
            WhatsApp
          </a>
          <span className="text-stone-700" data-id="element-109">·</span>
          <a href="mailto:yogavanesa@gmail.com" className="hover:text-violet-400 transition-colors" data-id="element-110">
            yogavanesa@gmail.com
          </a>
        </div>

        {/* Legal + Copyright */}
        <div className="pt-6 border-t border-stone-800/50 flex flex-col sm:flex-row items-center justify-center gap-2 text-[11px] text-stone-600 font-light" data-id="element-111">
          <p data-id="element-112">© {new Date().getFullYear()} VANII</p>
          <span className="hidden sm:inline text-stone-700" data-id="element-113">·</span>
          <div className="flex items-center gap-2" data-id="element-114">
            <button onClick={() => onOpenLegal('privacy')} className="hover:text-stone-400 transition-colors" data-id="element-115">
              Privacidad
            </button>
            <span className="text-stone-700" data-id="element-116">·</span>
            <button onClick={() => onOpenLegal('legal')} className="hover:text-stone-400 transition-colors" data-id="element-117">
              Aviso Legal
            </button>
          </div>
        </div>
      </div>
    </footer>;
}